// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__qjzpR","form":"styles_form__1XtuO"};